/**
 * Auth feature API layer — OpenAPI-first (§9.1, §9.3).
 */
import { authMe, useAuthUpdatePhone as useGenUpdatePhone } from "@shared/api/generated/auth/auth";
import { useQueryClient } from "@tanstack/react-query";

export const useUpdateMyPhone = () => {
  const qc = useQueryClient();
  const mutation = useGenUpdatePhone();
  const invalidateMe = () => {
    qc.invalidateQueries({ queryKey: ["auth", "me"] });
  };

  return {
    ...mutation,
    /** Backward-compatible wrapper: accepts a plain phone string. */
    mutate(phone: string, options?: Parameters<typeof mutation.mutate>[1]) {
      return mutation.mutate(
        { data: { phone } },
        {
          ...options,
          onSuccess: (...args) => {
            invalidateMe();
            options?.onSuccess?.(...args);
          },
        },
      );
    },
    async mutateAsync(phone: string, options?: Parameters<typeof mutation.mutateAsync>[1]) {
      return mutation.mutateAsync(
        { data: { phone } },
        {
          ...options,
          onSuccess: (...args) => {
            invalidateMe();
            options?.onSuccess?.(...args);
          },
        },
      );
    },
  };
};

export const getAuthMe = () => authMe();
